import apiClient from './apiClient';

class UserPermissionService {
  async getUserPermissions(userId) {
    try {
      const response = await apiClient.get(`/api/supplier/user-profile/user-permissions/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user permissions:', error);
      throw error;
    }
  }

  async grantPermission(userId, permissionName) {
    try {
      const response = await apiClient.post('/api/supplier/user-profile/grant-permission-to-user', {
        userId,
        permissionName
      });
      return response.data;
    } catch (error) {
      console.error('Error granting permission:', error);
      throw error;
    }
  }

  async revokePermission(userId, permissionName) {
    try {
      const response = await apiClient.post('/api/supplier/user-profile/revoke-permission-from-user', {
        userId,
        permissionName
      });
      return response.data;
    } catch (error) {
      console.error('Error revoking permission:', error);
      throw error;
    }
  }
}

export default new UserPermissionService(); 